/**
 * El botón "atrás" del sistema debe cerrar overlays antes de navegar.
 * pushState conserva el state existente (p. ej. `mlv` del browser history).
 */

/** @type {{ run: () => void }[]} */
const stack = [];
let ignoreNextPop = false;

function onPopState(ev) {
  if (ignoreNextPop) {
    ignoreNextPop = false;
    return;
  }
  const item = stack.pop();
  if (!item) return;
  item.run();
  ev.stopImmediatePropagation();
}

let listenerAdded = false;
function ensureListener() {
  if (listenerAdded) return;
  listenerAdded = true;
  window.addEventListener('popstate', onPopState, true);
}

/**
 * @param {() => void} cleanupDom - Quitar DOM y listeners (idempotente)
 * @returns {{ closeFromUi: () => void }}
 */
export function mlvModalHistoryAttach(cleanupDom) {
  ensureListener();
  let done = false;
  function run() {
    if (done) return;
    done = true;
    cleanupDom();
  }
  const item = { run };
  try {
    const prev = window.history.state || {};
    window.history.pushState(
      { ...prev, __mlvModal: true },
      '',
      window.location.href || ''
    );
  } catch (_e) {
    /* ignore */
  }
  stack.push(item);

  return {
    closeFromUi() {
      const i = stack.lastIndexOf(item);
      if (i !== stack.length - 1) {
        if (i >= 0) stack.splice(i, 1);
        run();
        return;
      }
      stack.pop();
      run();
      ignoreNextPop = true;
      try {
        window.history.back();
      } catch (_e) {
        ignoreNextPop = false;
      }
    },
  };
}
